import { useState } from "react";
import useEventListener from "./useEventListener";

export default function useDetectScreenOff() {
  const [isScreenOff, setScreenOff] = useState(window.document.hidden);

  useEventListener(
    "visibilitychange",
    () => {
      setScreenOff(window.document.hidden);
    },
    window.document
  );

  return isScreenOff;
}
